import React from "react";
import { Box } from "@mui/material";
import { StyledNotification } from "components/StyledUI";
import { BasketValidationType } from "_redux/selectors/order";

interface Props {
  validations?: BasketValidationType[];
}

const SellerGroupedNotifications: React.FC<Props> = ({ validations = [] }) => (
  <>
    {validations.map(({ key, validation }) => (
      <Box mb={1} key={key}>
        <StyledNotification
          severity={validation.type === "DENIAL" ? "error" : "warning"}>
          {validation.message}
        </StyledNotification>
      </Box>
    ))}
  </>
);

export default SellerGroupedNotifications;
